module.exports = __webpack_public_path__ + "static/media/grayTriangle.f807606d.svg";